import * as React from 'react'

import { TextField, TextFieldProps } from '@mui/material'
import { PatternFormatProps, PatternFormat } from 'react-number-format'

interface InputProps extends PatternFormatProps {
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
}

const PatternFormatInput = React.forwardRef(
  (props: InputProps, ref?: React.Ref<any>) => {
    const { onChange, ...rest } = props

    return (
      <PatternFormat
        {...rest}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          })
        }}
      />
    )
  },
)

export const PatternField = React.forwardRef(
  (props: TextFieldProps, ref?: React.Ref<any>) => {
    const { inputProps, InputProps, ...rest } = props

    return (
      <TextField
        variant="outlined"
        size="small"
        inputRef={ref}
        InputProps={{
          ...InputProps,
          inputComponent: PatternFormatInput as any,
          inputProps,
        }}
        {...rest}
      />
    )
  },
)
